import { render, staticRenderFns } from "./compatible-integrations-hint.vue?vue&type=template&id=ca4f01ea&scoped=true&"
import script from "./compatible-integrations-hint.vue?vue&type=script&lang=js&"
export * from "./compatible-integrations-hint.vue?vue&type=script&lang=js&"
import style0 from "./compatible-integrations-hint.vue?vue&type=style&index=0&id=ca4f01ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f01ea",
  null
  
)

export default component.exports